import { useQuery, useQueryClient } from "@tanstack/react-query";
import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { useContext } from "react";

const path = `${baseUrl}/people`;

export const {
  useGetAll: useAllPeople,
  useGet: usePeople,
  useGetAsync: usePeopleAsync,
  useCreate: useCreatePeople,
  useUpdate: useUpdatePeople,
  useDelete: useDeletePeople,
} = apiCrudBuilder(path, "People");

export const usePeopleContact = (peopleId, options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["People", peopleId, "contacts"],
    queryFn: () => {
      return appAxios
        .get(`${path}/${peopleId}/contacts/`)
        .then((res) => res.data);
    },
  });
};

export const useResetPeople = () => {
  const queryClient = useQueryClient();

  return (peopleId) => {
    queryClient.invalidateQueries({ queryKey: ["People", peopleId] });
  };
};
